import { render, staticRenderFns } from "./ColumnSelectionField.vue?vue&type=template&id=3877a5f3&scoped=true&"
import script from "./ColumnSelectionField.vue?vue&type=script&lang=ts&"
export * from "./ColumnSelectionField.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnSelectionField.vue?vue&type=style&index=0&id=3877a5f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3877a5f3",
  null
  
)

export default component.exports